{
  "title": "Arcane Gate",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level conjuration",
  "level": 6,
  "castingTime": "1 action",
  "range": "500 feet",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You create linked teleportation portals that remain open for the duration. Choose two points on the ground that you can see, one point within 10 feet of you and one point within 500 feet of you. A circular portal, 10 feet in diameter, opens over each point. If the portal would open in the space occupied by a creature, the spell fails, and the casting is lost.",
    "The portals are two-dimensional glowing rings filled with mist, hovering inches from the ground and perpendicular to it at the points you choose. A ring is visible only from one side (your choice), which is the side that functions as a portal.",
    "Any creature or object entering the portal exits from the other portal as if the two were adjacent to each other; passing through a portal from the nonportal side has no effect. The mist that fills each portal is opaque and blocks vision through it. On your turn, you can rotate the rings as a bonus action so that the active side faces in a different direction."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
